import { combineReducers } from 'redux'
import videoReducer from './Video/video.reducer'

const rootReducer = combineReducers({
  video: videoReducer,
})

export default rootReducer
